import React from 'react';
import { FiArrowRight, FiPlay } from 'react-icons/fi';
import './Hero.css';
import heroImage from '../../media/hero.png';

const Hero: React.FC = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero">
      <div className="hero__bg-grid" aria-hidden="true" />
      <div className="hero__glow hero__glow--left" aria-hidden="true" />
      <div className="hero__glow hero__glow--right" aria-hidden="true" />

      <div className="container hero__content" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="hero__badge">
          <span className="hero__badge-dot" />
          Software Development · Digital Media · Music
        </div>

        <h1 className="hero__title">
          Where Code Meets <span className="gradient-text">Creative Vision</span>
        </h1>

        <p className="hero__subtitle">
          CodeTunez Studios is a space where code, art, and sound move together.
          We build digital products, create visual work, and create and DJ music 
          with the same creative spirit.
          <br /><br />
          Unbound by labels. Driven by expression. Moved by imagination.
        </p>

        <div className="hero__actions">
          <button className="hero__btn hero__btn--primary" onClick={() => scrollTo('software')}>
            Explore Our Work <FiArrowRight />
          </button>
          {/* <button className="hero__btn hero__btn--secondary" onClick={() => scrollTo('contact')}>
            <FiPlay className="hero__play-icon" /> Get in Touch
          </button> */}
        </div>
      </div>

      <div className="hero__scroll-indicator" onClick={() => scrollTo('about')}>
        <div className="hero__scroll-dot" />
      </div>
    </section>
  );
};

export default Hero;
